/** 与 backend/utils/order/orderStatsBrand.js 口径一致（主件行按销售金额取主导品牌） */

const isObjectId = (str) => {
	if (!str || typeof str !== 'string') return false;
	return /^[0-9a-fA-F]{24}$/.test(str.trim());
};

export const resolveOrderItemBrandName = (item) => {
	if (!item) return '未分类';
	if (typeof item.brand === 'string') {
		const name = item.brand.trim();
		if (name && !isObjectId(name)) return name;
	}
	return '未分类';
};

const filterMainOrderItems = (orderItems) => {
	if (!Array.isArray(orderItems)) return [];
	return orderItems.filter((item) => {
		const price = Number(item?.sellingPrice);
		return Number.isFinite(price) && price > 0;
	});
};

export const resolveOrderStatsBrandNames = (order) => {
	const mainItems = filterMainOrderItems(order?.orderItems ?? []);
	const source = mainItems.length > 0 ? mainItems : order?.orderItems ?? [];
	const names = new Set();
	for (const item of source) {
		names.add(resolveOrderItemBrandName(item));
	}
	if (!names.size) names.add('未分类');
	return [...names].sort((a, b) => a.localeCompare(b, 'zh-CN'));
};

export const resolveOrderStatsBrandName = (order) => {
	if (order?.brandName) return order.brandName;
	if (Array.isArray(order?.brandNames) && order.brandNames.length) return order.brandNames[0];

	const mainItems = filterMainOrderItems(order?.orderItems ?? []);
	const source = mainItems.length > 0 ? mainItems : order?.orderItems ?? [];
	if (!source.length) return '未分类';

	let bestBrand = '未分类';
	let bestTotal = -1;
	const brandTotals = new Map();
	for (const item of source) {
		const brand = resolveOrderItemBrandName(item);
		const price = Number(item?.sellingPrice) || 0;
		const qty = Number(item?.qty) || 0;
		const lineTotal = price * qty;
		brandTotals.set(brand, (brandTotals.get(brand) ?? 0) + lineTotal);
	}

	for (const [brand, total] of brandTotals) {
		if (total > bestTotal || (total === bestTotal && brand.localeCompare(bestBrand, 'zh-CN') < 0)) {
			bestTotal = total;
			bestBrand = brand;
		}
	}

	return bestBrand;
};

export const orderContainsStatsBrand = (order, brandName) => {
	const target = String(brandName ?? '').trim();
	if (!target) return false;
	const names = Array.isArray(order?.brandNames) ? order.brandNames : resolveOrderStatsBrandNames(order);
	return names.includes(target);
};
